import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ChartDataSets, ChartOptions } from 'chart.js';
import { Color, Label } from 'ng2-charts';

@Component({
  selector: 'app-linechart',
  templateUrl: './line-chart.component.html',
  styleUrls: ['./line-chart.component.scss']
})
export class LinechartComponent implements OnInit {

  // @Input() public lineChartData: number[] = [];
  @Input() public lineChartData: ChartDataSets[] = [];
  @Input() public lineChartLabels: Label[] = [];
  @Output() valueChanged = new EventEmitter();

  public lineChartOptions: (ChartOptions & { annotation: any }) = {
    responsive: true,
    annotation: {}
  };
  public lineChartColors: Color[] = [
    {
      borderColor: 'black',
      backgroundColor: '#C6CEF7',
    },
  ];
  public lineChartLegend = false;
  public lineChartType = 'line';
  public lineChartPlugins = [];
  chartTypeList: any[] = [];
  frequencyList: any[] = [];
  chart_type: any;
  freq_type: any;


  ngOnInit() {
    this.chartTypeList = [
      { value: 'Pets_Cared', name: 'Pet Cared' },
      {
        value: 'Phone_Consultations', name: 'Phone Consultation'
      },
      {
        value: 'Total_Earnings', name: 'Total Earnings'
      },
      {
        value: 'Earned_by_Clinic', name: 'Earned by Clinic'
      },
      {
        value: 'Earned_by_Phone', name: 'Earned by Phone'
      }];
    this.chart_type = { value: 'Pets_Cared', name: 'Pet Cared' };
    this.freq_type = 'Day';
  }

  changeValue(type: string, value: any) {
    if (type === 'chart') {
      this.valueChanged.emit({ type, value });
    } else if (type === 'frequency') {
      this.valueChanged.emit({ type, value });
    }
  }

  // events
  public chartClicked(e: any): void {
    // console.log(e);
  }

  public chartHovered(e: any): void {
    // console.log(e);
  }

}
